import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AclDropdownItemComponent } from './dropdown-item.component';

@NgModule({
  declarations: [AclDropdownItemComponent],
  imports: [CommonModule],
  exports: [AclDropdownItemComponent],
  schemas: [],
})
export class AclDropdownItemModule {}
